import React from "react";
import { GenericListProps } from "../../types/GenericListType";
import { List } from "../List";
import { OrderedList } from "../OrderedList";

interface Props {
  childListContentItem: GenericListProps;
  indentationLevel?: number;
}

export const NestedList: React.FC<Props> = ({
  childListContentItem,
  indentationLevel,
}) => {
  const { icon } = childListContentItem;
  return (
    //  Can be of two types - 1) Ordered i.e. list items without an icon but instead preceded by a number OR
    //  2) Unordered i.e. list items with an icon preceding each item
    icon ? (
      <List indentationLevel={indentationLevel} {...childListContentItem} />
    ) : (
      <OrderedList
        indentationLevel={indentationLevel}
        {...childListContentItem}
      />
    )
  );
};
